import React, { useState } from 'react';
import { Grid } from '@mui/material';
import Button, { IButtonProps } from 'src/components/bootstrap/Button';
import FormGroup from 'src/components/bootstrap/forms/FormGroup';
import Input from 'src/components/bootstrap/forms/Input';
import Select from 'src/components/bootstrap/forms/Select';
import Option from 'src/components/bootstrap/Option';
import { getStorage, setStorage } from 'src/utils/utils';

import logo2FA from 'src/assets/img/g2fa.png';
import QRCode from 'react-qr-code';

const Auth2FA = ({ handleSunmit2FA, QR, token, setToken }) => {
	return (
		<div
			style={{
				zIndex: '9999',
				width: '100%',
				height: '100vh',
				backgroundRepeat: 'no-repeat',
				backgroundImage: 'linear-gradient(to right, red , orange)',
			}}>
			<Grid container className='grid_auth2fa'>
				<Grid
					xl='3'
					lg='6'
					md='8'
					style={{
						padding: '1.5rem',
						backgroundColor: 'rgb(255,255,255,0.5)',
						borderRadius: '10px',
						border: '1px solid gray',
						margin: '1rem',
					}}>
					<div className='justify-content-center'>
						<img src={logo2FA} className='mb-4 logo-icas w-100' />
					</div>

					<center className=''>
						{QR && <QRCode value={QR} />}
						{/* <img
                src={logo2FA}
                style={{
                  width: "30px",
                  height: "30px",
                  position: "absolute",
                  top: 15,
                  left: 15,
                }}
              /> */}
					</center>

					<FormGroup className='div_enter2fa'>
						<Input
							style={{
								height: '45px',
								width: 'calc(100% - 80px)',
								borderTopLeftRadius: '7px',
								borderBottomLeftRadius: '7px',
								fontSize: '18px',
							}}
							placeholder={`Enter 2FA Code`}
							value={token}
							maxLength={6}
							onChange={({ target: { value } }) => setToken(value)}
							autoFocus
							onKeyPress={(e) => (e.key === 'Enter' ? handleSunmit2FA(token) : null)}
							type='text'
						/>
						<Button
							color='info'
							className='btn_login'
							style={{
								height: 'auto',
								width: '80px',
								borderTopRightRadius: '7px',
								borderBottomRightRadius: '7px',
							}}
							onClick={() => {
								handleSunmit2FA(token);
							}}>
							Confirm
						</Button>
					</FormGroup>
				</Grid>
			</Grid>
		</div>
	);
};

export default Auth2FA;
